import { LoginOrRegisterPage } from "@web/pages/login/LoginOrRegisterPage";
import Head from "next/head";

export default function Register() {
  return (
    <>
      <Head>
        <title>Harken | Sign Up</title>
      </Head>
      <LoginOrRegisterPage loginOrRegister="register" />
    </>
  );
}
